if (typeof PasswordModal !== 'function') {
	class PasswordModal extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				openModal: '.password-modal__toggle-open',
				closeModal: '.password-modal__close-button',
				modal: '.password-modal',
				formMessage: '.password-form .visually-hidden',
			};

			this.elements = {
				openModal: document.querySelector(this.selectors.openModal),
				closeModal: document.querySelector(this.selectors.closeModal),
				modal: document.querySelector(this.selectors.modal),
				formMessage: document.querySelector(this.selectors.formMessage),
			};

			this.classes = {
				open: 'password-modal--open',
				close: 'password-modal--close',
			};

			this.init();
		}

		init() {
			this.elements.openModal.addEventListener('click', () => {
				this.elements.modal.classList.add(this.classes.open);
				this.elements.modal.classList.remove(this.classes.close);
			});

			this.elements.closeModal.addEventListener('click', () => {
				this.elements.modal.classList.add(this.classes.close);
				this.elements.modal.classList.remove(this.classes.open);
			});

			if (this.elements.formMessage?.innerHTML == 'Error') {
				this.elements.modal.classList.add(this.classes.open);
			}
		}
	}

	if (!customElements.get('password-modal')) {
		customElements.define('password-modal', PasswordModal);
	}
}

function setCSSVariables() {
	this.selectors = {
		footer: 'shopify-section-main-password-footer',
		header: '.password-header',
	};

	this.elements = {
		footer: document.getElementById(this.selectors.footer),
		header: document.querySelector(this.selectors.header),
	};

	this.headerHeight = 0;
	this.footerHeight = 0;

	if (this.elements.footer) {
		this.footerHeight = this.elements.footer.clientHeight;

		document.body.style.setProperty('--footer-height', `${this.footerHeight}px`);
	}

	if (this.elements.header) {
		this.headerHeight = this.elements.header.clientHeight;

		document.body.style.setProperty('--header-height', `${this.headerHeight}px`);
	}
}

setCSSVariables();
